var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3671_93624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9L31 31",
    stroke: "#ADADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 17.3401V12.0001C23.0007 11.2561 22.725 10.5384 22.2264 9.98629C21.7277 9.43417 21.0417 9.08703 20.3015 9.01227C19.5613 8.9375 18.8197 9.14043 18.2207 9.58168C17.6217 10.0229 17.208 10.671 17.06 11.4001M17 17.0001V20.0001C17.0005 20.5931 17.1768 21.1726 17.5064 21.6654C17.8361 22.1583 18.3045 22.5424 18.8523 22.7692C19.4002 22.9961 20.0029 23.0555 20.5845 22.94C21.1661 22.8244 21.7005 22.5391 22.12 22.1201L17 17.0001Z",
    stroke: "#ADADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 24.95C24.024 25.9464 22.7723 26.6285 21.4058 26.9086C20.0393 27.1887 18.6202 27.0542 17.3307 26.5223C16.0411 25.9903 14.9399 25.0853 14.1684 23.9232C13.3968 22.761 12.99 21.3949 13.0002 20V18M27.0002 18V20C26.9998 20.4124 26.963 20.824 26.8902 21.23",
    stroke: "#ADADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 27V31",
    stroke: "#ADADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 31H24",
    stroke: "#ADADAD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3671_93624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMute);
export default __webpack_public_path__ + "static/media/icon_mute.58106fe292c459c20f139ba71804d0e1.svg";
export { ForwardRef as ReactComponent };